import { FilterChip } from '@marqvision/shared';
import { useGetFilterParams, usePathParams } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';

export const TrademarkTextFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { params, setParams, removeParams } = useGetFilterParams();
  const { page, listingStatus } = usePathParams();
  const { amplitudeLogging } = useLogger();

  const isSelected = Boolean(params.tm_text);

  const handleToggle = () => {
    amplitudeLogging('applied filter', {
      Type: 'tm_text',
      Channel: page,
      Page: getListingTabGroup(listingStatus),
    });

    if (isSelected) {
      removeParams(['tm_text']);
    } else {
      setParams({ tm_text: true }, { replace: true });
    }
  };

  return (
    <FilterChip type="toggle" label="Trademarked text used" selected={isSelected} size={size} onClick={handleToggle} />
  );
};
